import { HRegex } from "@macashipo/mlib"
export const RGSquareBracket = HRegex.RGSquareBracket
